import { ListItemButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeviceType } from "@hook/useDeviceType";
import { useStyle } from "../style";
import { useNavigationLinks } from "../hook/useNavigationLinks";
import { NavigationLinkMobile } from "./NavigationLinkMobile";
import { BUTTON_IDS } from "@utils/GTM/buttonIds";

interface IParams {
    onLogout?(): void;
    onNavigate?(): void;
}

export const NavigationMobile = (props: IParams) => {
    const { onLogout, onNavigate } = props;
    const { t } = useTranslation("header");
    const { isDesktop } = useDeviceType();
    const { classes } = useStyle({ isDesktop });
    const links = useNavigationLinks();

    return (
        <>
            {links.map((link) => (
                <NavigationLinkMobile key={link.title} link={link} onNavigate={onNavigate} />
            ))}
            <ListItemButton
                className={classes.drawerMenuItem}
                component="div"
                disableGutters
                divider
                id={BUTTON_IDS.TOP_NAV.LOGOUT}
                role="button"
                tabIndex={0}
                onClick={onLogout}
            >
                <Typography className={classes.drawerMenuItemText} variant="large">
                    {t("logout")}
                </Typography>
            </ListItemButton>
        </>
    );
};
